/**
 * Image loading helpers for product images and source images
 */
import { toast } from 'sonner';

export async function loadImageViaProxy(imageUrl: string): Promise<Blob> {
  const proxyUrl = `/api/v1/images/proxy?url=${encodeURIComponent(imageUrl)}`;
  const response = await fetch(proxyUrl, { credentials: 'include' });
  if (!response.ok) throw new Error(`Proxy-Fehler: ${response.status}`);
  return response.blob();
}

export async function loadSourceImage(
  imageId: string,
  onSuccess: (file: File, preview: string, info: { id: string; name: string }) => void,
  onError: () => void
) {
  try {
    const imageUrl = `/image/${imageId}`;
    const response = await fetch(imageUrl, { credentials: 'include' });
    if (!response.ok) throw new Error(`Bild konnte nicht geladen werden: ${response.status}`);

    const blob = await response.blob();
    const contentType = blob.type || 'image/png';
    const extension = contentType.split('/')[1] || 'png';
    const filename = `continue_${imageId}.${extension}`;
    const file = new File([blob], filename, { type: contentType });

    onSuccess(file, imageUrl, { id: imageId, name: 'Weiterverarbeitung' });
    toast.success('Bild für Weiterverarbeitung geladen');
  } catch (err) {
    console.error('Error loading source image:', err);
    toast.error('Bild konnte nicht geladen werden');
    onError();
  }
}

export async function loadProductImage(
  imageUrl: string,
  productId: string,
  productName: string,
  onSuccess: (file: File, preview: string, info: { id: string; name: string }) => void,
  onError: () => void
) {
  try {
    const blob = await loadImageViaProxy(imageUrl);
    const contentType = blob.type || 'image/png';
    const extension = contentType.split('/')[1] || 'png';
    const filename = `product_${productId}.${extension}`;
    const file = new File([blob], filename, { type: contentType });

    onSuccess(file, imageUrl, { id: productId, name: productName });
    toast.success(`Produktbild "${productName || productId}" geladen`);
  } catch (err) {
    console.error('Error loading product image:', err);
    toast.error('Produktbild konnte nicht geladen werden');
    onError();
  }
}
